import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, DatePicker, Spin, Typography } from "antd";
import EmbeddedExperienceCard from "../ExperienceCard";
import styles from "./ExperienceListing.module.css";
import EmbeddedBookingLayout from "../EmbeddedBookingLayout";
import { Icon } from "ui/Icon";
import { fetchExperiencesByGuide } from "store/experiences";
import experiencesSVG from "assets/imagesV2/experiences.svg"

const { Text, Title } = Typography;

const EmbeddedExperienceListing = () => {
    const [t] = useTranslation()
    const { uuid } = useParams();
    const dispatch = useDispatch();
    const { byGuide } = useSelector((state) => state.experiences);
    const [page, setPage] = useState(1);

    const handleSeeMore = () => {
        const nextPage = page + 1;
        dispatch(fetchExperiencesByGuide(uuid, nextPage));
        setPage(nextPage);
    };

    useEffect(() => {
        if (uuid) {
            setPage(1);
            dispatch(fetchExperiencesByGuide(uuid));
        }
    }, [uuid, dispatch]);

    return (
        <>
            {byGuide?.loading && (
                <div className={styles.loaderOverlay}>
                    <Spin size="large" />
                </div>
            )}
            <EmbeddedBookingLayout type={"experience_listing"}>
                <Text className={styles.heading}>{t("webIntegration.choose_your_experience")}</Text>
                <Text className={styles.subheading}>
                    {t("webIntegration.listing_description")}
                </Text>
                <div style={{ marginTop: "24px" }}>
                    <Text className={styles.whenLabel}>{t("webIntegration.when")}</Text>
                    <div className={styles.dateSearchBar}>
                        <DatePicker style={{ border: "none" }} />
                        <Button type="primary">{t("webIntegration.search")}</Button>
                    </div>
                </div>
                <div style={{ marginTop: "40px" }}>
                    <Text className={styles.availableHeading}>{t("webIntegration.available_experience")}</Text>
                    {byGuide?.data?.length ?
                        <>
                            <div className={styles.grid}>
                                {byGuide?.data?.map((exp, index) => (
                                    <EmbeddedExperienceCard
                                        key={index + 1}
                                        image={exp?.photos?.find((item) => item?.position === 0)?.preview_url}
                                        title={exp?.title}
                                        location={exp?.address}
                                        time={exp?.available_hours?.[0]}
                                        people={exp?.max_guests}
                                        price={exp?.price_per_person}
                                        experienceId={exp?.uuid}
                                    />
                                ))}
                            </div>
                            {byGuide.data?.length < byGuide?.metaData?.total_results && (
                                <div style={{ textAlign: "center", marginTop: "24px" }}>
                                    <Button onClick={handleSeeMore} variant="outlined" color="primary">
                                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            {t("webIntegration.see_more")}
                                            <Icon type="feather" name="ChevronDown" />
                                        </span>
                                    </Button>
                                </div>
                            )}
                        </> :
                        !byGuide?.loading &&
                        <div className={styles.emptyBlock}>
                            <img src={experiencesSVG} alt="empty" height={"300px"} />
                            <Title level={3}>No Data Found.</Title>
                        </div>
                    }
                </div>
            </EmbeddedBookingLayout>
        </>
    );
};

export default EmbeddedExperienceListing;
